import { ActionReducerMap } from "@ngrx/store";
import { reducerUser } from "./user/user.reducer";

export const REDUCERS: ActionReducerMap<any> = {
    user: reducerUser,
};